module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/purple.png?9284a128";